import React, { useState, useEffect } from 'react';
import styles from './nav-header.module.css';
import logo from './images/logo.jpg';

const NavHeader = () => {
    const [isActive, setIsActive] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const [activeLink, setActiveLink] = useState('/home');
    const [signUpPageActive, setSignUpPageActive] = useState(false);
    const [loginPageActive, setLoginPageActive] = useState(false);

    const toggleNavbar = () => {
        setIsActive(!isActive);
    };

    const closeNavbar = () => {
        setIsActive(false);
    };

    // Handle scroll effect
    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.pageYOffset;
            setIsScrolled(scrollTop > 50);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Handle active link and page states
    useEffect(() => {
        const currentPath = window.location.pathname;
        setActiveLink(currentPath);

        if (currentPath === '/signup') {
            setSignUpPageActive(true);
            setLoginPageActive(false);
        } else if (currentPath === '/login') {
            setLoginPageActive(true);
            setSignUpPageActive(false);
        } else {
            // Default behavior - show login when not on signup/login pages
            setLoginPageActive(true);
            setSignUpPageActive(false);
        }
    }, []);

    const handleLinkClick = (href) => {
        setActiveLink(href);
        closeNavbar();
        
        // Update page states when links are clicked
        if (href === '/signup') {
            setSignUpPageActive(true);
            setLoginPageActive(false);
        } else if (href === '/login') {
            setLoginPageActive(true);
            setSignUpPageActive(false);
        }
    };

    const navItems = [
        { href: '/guest/home', label: 'Home' },
        { href: '/guest/project-networks', label: 'Projects' },
        { href: '/applied-interns', label: 'Applied' },
        { href: '/recruiter-messages', label: 'Recruiters' },
        { href: '/guest/messages', label: 'Messages'},
        { href: '/profile', label: 'Profile' },
        { href: '/settings', label: 'Settings' },
        // Only include the active auth option
        ...(signUpPageActive ? [{ href: '/signup', label: 'Signup' }] : []),
        ...(loginPageActive ? [{ href: '/login', label: 'Login' }] : [])
    ];

    return (
        <nav className={`${styles.navbar} ${isActive ? styles.navbarActive : ''} ${isScrolled ? styles.scrolled : ''}`}>
            <div onClick={() => window.location.href = '/'} className={styles.logoContainer}>
                <img className={styles.logo} src={logo} alt="Logo" />
                <div className={styles.navbarLogo}>UNPAID INTERNSHIPS</div>
            </div>
            
            <ul className={styles.navbarLinks}>
                {navItems.map((item, index) => (
                    <li key={index}>
                        <a 
                            href={item.href}
                            className={activeLink === item.href ? styles.active : ''}
                            onClick={() => handleLinkClick(item.href)}
                            data-badge={item.badge}
                        >
                            {item.label}
                        </a>
                    </li>
                ))}
            </ul>
            
            <button 
                className={styles.navbarToggle} 
                onClick={toggleNavbar}
                aria-label="Toggle navigation menu"
                aria-expanded={isActive}
            >
                <span className={styles.bar}></span>
                <span className={styles.bar}></span>
                <span className={styles.bar}></span>
            </button>
        </nav>
    );
};

export default NavHeader;